/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-03 10:46:16
 * @LastEditTime: 2021-06-25 10:14:43
 * @Description: 用户api
 */
import axios from '@/utils/axios'

export const getUserList = (payload) => {
    return axios.get('/user', {
        params: payload
    })
}

export const getSimpleUserList = (payload) => {
    return axios.get('/simple_user_list', {
        params: payload
    })
}

export const createUser = (data) => {
    return axios.post(`/user`, data)
}

export const updateUser = (id, data) => {
    return axios.put(`/user/${id}`, data)
}

export const adminChangeUserPassword = (id, data) => {
    return axios.put(`/user/change_password/${id}`, {
        password: data
    })
}

export const bannedUser = (id) => {
    return axios.post(`/user/banned/${id}`)
}

export const recover = (id) => {
    return axios.post(`/user/recover/${id}`)
}

export const adminResetUserPassword = (id) => {
    return axios.put(`/user/reset_password/${id}`)
}